var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasteUsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Taste",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.242,
    height: 29.018,
    viewBox: "0 0 41.242 29.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3799",
    "data-name": "Rectangle 3799",
    width: 41.242,
    height: 29.019,
    fill: "#143727"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9651",
    "data-name": "Group 9651",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33774",
    "data-name": "Path 33774",
    d: "M340.525,15.707c-.261.213-.482.475-.892.413a7.279,7.279,0,0,0-1.041-.01v.448q0,5.294,0,10.588a1.752,1.752,0,0,1-.619,1.469,1.479,1.479,0,0,1-1.531.3,1.463,1.463,0,0,1-1.063-1.414q-.012-13.426-.007-26.851a.6.6,0,0,1,.7-.651,4.692,4.692,0,0,1,2.462.787,4.539,4.539,0,0,1,1.836,2.621,2.683,2.683,0,0,0,.156.375Zm-1.289-.9V14.4q0-4.526,0-9.053c0-.437-.039-.874-.079-1.31a3.02,3.02,0,0,0-2.479-2.632v13.4Zm-2.578,1.327c0,3.744,0,7.457.012,11.169,0,.136.177.271.272.407a4.138,4.138,0,0,0,.354-.388c.038-.053.007-.156.007-.237V16.113c-.2,0-.345,0-.491,0a1.514,1.514,0,0,0-.153.021",
    transform: "translate(-299.282 0)",
    fill: "#143727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33775",
    "data-name": "Path 33775",
    d: "M59.666,14.8A14.346,14.346,0,0,1,63.538,4.774a14.508,14.508,0,0,1,20.887-.4A13.867,13.867,0,0,1,88.6,13.418a14.06,14.06,0,0,1-4.188,11.4,14.083,14.083,0,0,1-11.162,4.28,13.9,13.9,0,0,1-9.637-4.565A14.182,14.182,0,0,1,59.666,14.8m1.3-.168A12.946,12.946,0,0,0,65.1,24.178a13.109,13.109,0,0,0,18.611-.453,12.862,12.862,0,0,0,3.6-10.283,13.2,13.2,0,0,0-26.35,1.186",
    transform: "translate(-53.245 -0.119)",
    fill: "#143727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33776",
    "data-name": "Path 33776",
    d: "M1.291,5.806h.644v-.4q0-2.316,0-4.631c0-.489.231-.77.612-.76A.732.732,0,0,1,3.223.8q0,2.3,0,4.591V5.8h.644V2.737c0-.644,0-1.289,0-1.933,0-.5.208-.779.585-.786a.725.725,0,0,1,.7.793c0,1.65,0,3.3,0,4.977h.628c0-.1.016-.211.016-.326q0-2.316,0-4.631c0-.535.209-.815.6-.813s.689.349.689.847c0,2.457.006,4.913,0,7.37a2.654,2.654,0,0,1-1.732,2.583.444.444,0,0,0-.192.239.809.809,0,0,0-.007.279q0,7.934,0,15.867A1.715,1.715,0,0,1,4.107,28.9a1.551,1.551,0,0,1-2.164-1.341q-.019-8.074,0-16.149a.589.589,0,0,0-.41-.659A2.385,2.385,0,0,1,0,8.442C0,5.892,0,3.341,0,.791,0,.292.221.016.6.018A.735.735,0,0,1,1.29.825c0,1.649,0,3.3,0,4.981m4.546,1.32H1.293c0,.5-.011.982,0,1.461A1.3,1.3,0,0,0,2.414,9.678c.723.009,1.445,0,2.168,0A1.311,1.311,0,0,0,5.718,8.72c.056-.522.08-1.048.119-1.593M3.224,10.979v.276q0,8.007,0,16.014c0,.054-.02.121,0,.158.07.106.142.253.243.281a.36.36,0,0,0,.313-.148,1,1,0,0,0,.081-.457q.005-7.886,0-15.772c0-.116-.011-.232-.017-.351Z",
    transform: "translate(-0.001 -0.016)",
    fill: "#143727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33777",
    "data-name": "Path 33777",
    d: "M101.811,52.065a9.977,9.977,0,0,1,17-7.042,9.519,9.519,0,0,1,2.953,7.1,10.065,10.065,0,0,1-10.729,9.966,9.987,9.987,0,0,1-9.224-10.024m9.92,8.745a8.7,8.7,0,1,0,.061-17.394,8.257,8.257,0,0,0-6.151,2.514,8.535,8.535,0,0,0-2.537,6.95,8.743,8.743,0,0,0,8.627,7.93",
    transform: "translate(-90.855 -37.612)",
    fill: "#143727"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteUsp);
export default __webpack_public_path__ + "static/media/Taste_usp.37723f5c9b46c15f99424b0cba484684.svg";
export { ForwardRef as ReactComponent };